import React from "react";
import { useNavigate } from "react-router-dom";
import { UserRoundSearch } from "lucide-react";
import { userProfilesAPI } from "../services/api";
import {
  buildMeetPeopleNavigationState,
  mergeDiscoverRouteCache,
} from "../utils/discoverRouteCache";
import "./NavigationButtons.css";

const MeetPeopleButton = ({
  title = "Meet People",
  disabled = false,
  className = "nav-button nav-button-meet",
}) => {
  const navigate = useNavigate();

  const handleClick = async (event) => {
    if (disabled) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    const cachedState = buildMeetPeopleNavigationState();
    if (cachedState) {
      navigate("/meet-people", { state: cachedState });
      return;
    }

    try {
      const response = await userProfilesAPI.getDiscoverPeople();
      const discoverPeople = response.data.people || [];
      mergeDiscoverRouteCache({ discoverPeople });
      navigate("/meet-people", {
        state: { prefetchedPeople: discoverPeople },
      });
      return;
    } catch {
      // Navigation should still work if the optimization fetch fails.
    }

    navigate("/meet-people", {
      state: cachedState,
    });
  };

  return (
    <button
      className={className}
      onClick={disabled ? undefined : handleClick}
      title={title}
      aria-label={title}
      type="button"
      disabled={disabled}
    >
      <UserRoundSearch size={18} strokeWidth={2} />
    </button>
  );
};

export default MeetPeopleButton;
